import { Box, Button, Typography, styled } from '@mui/material'
import React, { useEffect, useState } from 'react'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { colors } from '../../../../../constants/colors';
import { getToken } from '../../../../../utils/app.utils';
import { useLocation } from 'react-router-dom';




const ImageContainer = styled('div')({
    width: "100%",
    height: '100%',
    minHeight: "189px",
    backgroundImage: ` url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='11' ry='11' stroke='%23C1C3C7' stroke-width='4' stroke-dasharray='2%2c 8' stroke-dashoffset='0' stroke-linecap='round'/%3e%3c/svg%3e")`,
    borderRadius: "10px",
    marginTop: "0.5rem",
    display: "flex",
    padding: '12px',
    gap: "8px",
    flexWrap: "wrap"
})
type Props = {
    disableHeading?: boolean;
    heading?: string;
    headingVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body1' | 'body2' | 'subtitle1' | 'subtitle2';
    onChange: (data: any, mainIndex: number) => void;
    onFileOnly?: boolean;
    valueImage: any[];
    valueAddFile: any[];
    tabIndex: number;
    handleDeleteImageApi: (mainIndex: number, fileIndex: number) => void
    handleDeleteImageSelect: (mainIndex: number, imgIndex: number) => void
}

const ImageTracking = (props: Props) => {
    const token = getToken();

    const location = useLocation();
    const isViewCheck: boolean = location.pathname.includes('view');
    const [fileImage, setFileImage] = useState<File[]>(props.valueAddFile);
    const [pathUrl, setPathUrl] = useState<any>(null);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files) {
            if (files.length > 1) {
                props.onChange(Array.from(files), props.tabIndex)
            } else {
                props.onChange(files[0], props.tabIndex)

            }
        }
    };


    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results)
        }
        init();
    }, [])

    // console.log(pathUrl)

    // useEffect(() => {
    //     props.onChange && props.onChange(fileImage)
    // }, [fileImage])

    return (
        <section className='w-full mt-1'>
            <article
                style={{ display: props.disableHeading ? 'none' : 'block' }}
            >
                <Typography className='text-primary text-2xl' variant={props.headingVariant ? props.headingVariant : 'h6'}>
                    {"รูปภาพ"}
                </Typography>
            </article>
            {props.heading && (
                <article className='w-full'>
                    <Typography variant={props.headingVariant ? props.headingVariant : 'h5'}>
                        {props.heading}
                    </Typography>
                </article>
            )}
            <article>
                <ImageContainer>
                    {props.onFileOnly ? (
                        <>

                        </>
                    ) : (
                        <>
                            {props.valueImage.length > 0 && props.valueImage?.map((list: any, index: number) => (
                                <Box key={index} className="flex flex-col flex-wrap">
                                    {/* {JSON.stringify(list)} */}
                                    <div className='w-[140px] h-[140px] border-2 object-cover overflow-hidden rounded-lg'>
                                        {list instanceof File ? (
                                            <img
                                                className='w-full h-full object-cover'
                                                src={URL.createObjectURL(list) || ''}
                                                alt={`img-${index}`}
                                            />
                                        ) : (
                                            <img
                                                onClick={() => window.open(`${pathUrl.REACT_APP_BASE_API}/files/${list?.idFile}/view?access-token=${token}`)}
                                                className='w-full h-full object-cover cursor-pointer hover:opacity-70'
                                                src={pathUrl && `${pathUrl.REACT_APP_BASE_API}/files/${list?.idFile}/view?access-token=${token}`}
                                                alt={`img-${index}`}
                                            />
                                        )}
                                    </div>
                                    <div className='flex gap-1'>
                                        <Typography>{list?.fileName?.substring(0, 10)}</Typography>
                                        <Button
                                            onClick={() => props.handleDeleteImageApi(props.tabIndex, index)}
                                            sx={{ color: colors.lampang_text_secondary, width: '10px', padding: "0" }}
                                            startIcon={<HighlightOffIcon />}
                                        />
                                    </div>
                                </Box>
                            ))}
                            {props?.valueAddFile?.map((list: any, index: number) => (
                                <Box key={index} className="flex flex-col flex-wrap">
                                    <div className='w-[140px] h-[140px] border-2 object-cover overflow-hidden rounded-lg'>
                                        <img
                                            className='w-full h-full object-cover'
                                            src={URL.createObjectURL(list) || ''}
                                            alt={`img-${index}`}
                                        />
                                    </div>
                                    <div className='flex gap-1'>
                                        <Typography>{list?.name?.substring(0, 10)}</Typography>
                                        <Button
                                            onClick={() => props.handleDeleteImageSelect(props.tabIndex, index)}
                                            sx={{ color: colors.lampang_text_secondary, width: '10px', padding: "0" }}
                                            startIcon={<HighlightOffIcon />}
                                        />
                                    </div>
                                </Box>
                            ))}
                        </>
                    )}

                    <label htmlFor="upload-image-project-status" className='w-full max-w-[140px] h-full cursor-pointer' >
                        <div className='w-full max-w-[140px] bg-light h-full min-h-[140px] flex justify-center items-center rounded-xl'>
                            <AddCircleOutlineIcon sx={{ fontSize: "calc(1vw + 7rem)", color: "#C1C3C7" }} className='w-full' />
                        </div>
                        <div>
                            เพิ่มรูปภาพ
                        </div>
                    </label>
                </ImageContainer>
                <input
                    disabled={isViewCheck}
                    onChange={handleFileChange}
                    multiple accept="image/*"
                    id='upload-image-project-status'
                    className='hidden'
                    type="file"
                />
            </article>
        </section>
    )
}

export default ImageTracking